export default __webpack_public_path__ + "static/media/roof.8cafb45c.png";